import { FactoryInstance } from '../../../factory';
import { Form } from './Form';
import { FormAlert } from './FormAlert';
import { FormField } from './FormField';
import { FormFieldArray } from './FormFieldArray';
import { FormInput } from './FormInput';
import { FormSelect } from './FormSelect';
export * from './components/FormRadioInputGroup';
export * from './Form';
export * from './FormAlert';
export * from './FormField';
export * from './FormFieldArray';
export * from './FormInput';
export * from './FormSelect';
FactoryInstance.registerComponent(FormInput);
FactoryInstance.registerComponent(FormSelect);
FactoryInstance.registerComponent(FormField);
FactoryInstance.registerComponent(FormFieldArray);
FactoryInstance.registerComponent(FormAlert);
FactoryInstance.registerComponent(Form);
